document.addEventListener('DOMContentLoaded', function() {
    let triggers = document.querySelectorAll('.hover-trigger');
    let allContent = document.querySelectorAll('.healing-process__right');
    let allSubtitles = document.querySelectorAll('.healing-process__subtitle');
    let accordionTriggers = document.querySelectorAll('.accordion-trigger');
    let allMobileContent = document.querySelectorAll('.healing-process__mobile-content');

    // Check if mobile/tablet view (accordion mode)
    function isMobile() {
        return window.innerWidth <= 1121;
    }

    // Initialize desktop hover functionality
    allContent.forEach((content, index) => {
        if (index !== 0) {
            content.classList.remove('active');
        }
    });

    allSubtitles.forEach((subtitle, index) => {
        if (index !== 0) {
            subtitle.classList.remove('active');
        }
    });

    // Desktop hover functionality
    triggers.forEach(trigger => {
         trigger.addEventListener('mouseenter', function() {
            if (!isMobile()) {
                accordionTriggers.forEach((accordion) =>{
                    accordion?.classList.remove('active');
                });
                this.classList.add('active');
                
                let targetId = this.getAttribute('data-target');
                let stepNumber = this.getAttribute('data-step');
                let subtitleId = 'step-subtitle-' + stepNumber;
                
                allContent.forEach((content) =>{
                    content?.classList.remove('active');
                });
                
                allSubtitles.forEach((subtitle) => {
                    subtitle?.classList.remove('active');
                });
                
                let targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.classList.add('active');
                }
                
                let targetSubtitle = document.getElementById(subtitleId);
                if (targetSubtitle) {
                    targetSubtitle.classList.add('active');
                }
            }
        });

        trigger.addEventListener('mouseleave', function() {
            // if (!isMobile()) {
            //     let targetId = this.getAttribute('data-target');
            //     let stepNumber = targetId.replace('step-content-', '');
            //     let subtitleId = 'step-subtitle-' + stepNumber;
                
            //      let targetContent = document.getElementById(targetId);
            //     if (targetContent) {
            //         targetContent.classList.remove('active');
            //     }
                
            //     let targetSubtitle = document.getElementById(subtitleId);
            //     if (targetSubtitle) {
            //         targetSubtitle.classList.remove('active');
            //         // accordionTriggers.forEach((accordion) =>{
            //         //     accordion?.classList.remove('active');
            //         // });
            //         //this.classList.remove('active');
            //     }
                
            //     if (allContent.length > 0 && allContent[0]) {
            //         allContent[0].classList.add('active');
            //     }
                
            //     if (allSubtitles.length > 0 && allSubtitles[0]) {
            //         allSubtitles[0].classList.add('active');
            //     }
            // }
        });
    });

    // Mobile accordion functionality
    accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            if (isMobile()) {
                e.preventDefault();
                e.stopPropagation();
                
                let stepNumber = this.getAttribute('data-step');
                let mobileContentId = 'mobile-step-content-' + stepNumber;
                let mobileContent = document.getElementById(mobileContentId);
                
                // Check if this accordion is already open
                let isOpen = this.classList.contains('accordion-open');
                
                // Close all accordions
                accordionTriggers.forEach(t => {
                    t.classList.remove('accordion-open');
                });
                
                allMobileContent.forEach(content => {
                    content.classList.remove('active');
                });
                
                // If it wasn't open, open this one
                if (!isOpen && mobileContent) {
                    this.classList.add('accordion-open');
                    mobileContent.classList.add('active');
                }
                accordionTriggers.forEach((accordion) => {
                    accordion?.classList.remove('active');
                });
                this.classList.add('active');
            } else {
                // Desktop: sync content with hover target
                accordionTriggers.forEach((accordion) => {
                    accordion?.classList.remove('active');
                });
                this.classList.add('active');
                let targetId = this.getAttribute('data-target');
                allContent.forEach((content) => {
                    content?.classList.remove('active');
                });
                let targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.classList.add('active');
                }
            }
        });
    });

    // Initialize first accordion as open on mobile
    function initializeMobileAccordion() {
        if (isMobile()) {
            let firstTrigger = document.querySelector('.accordion-trigger[data-step="1"]');
            let firstMobileContent = document.getElementById('mobile-step-content-1');
            
            if (firstTrigger && firstMobileContent) {
                firstTrigger.classList.add('accordion-open');
                firstMobileContent.classList.add('active');
            }
        }
    }

    /**
     * Set min-height of all right (tab) content panels to the tallest panel height,
     * so the section doesn't shift when switching tabs on desktop.
     */
    function setRightColumnMinHeight() {
        if (isMobile() || !allContent.length) return;
        var maxHeight = 0;
        var i, h;
        // Temporarily show each panel one by one and measure its height
        for (i = 0; i < allContent.length; i++) {
            allContent.forEach(function(el, j) {
                el.style.display = j === i ? 'flex' : 'none';
            });
            h = allContent[i].offsetHeight;
            if (h > maxHeight) maxHeight = h;
        }
        // Set min-height on all panels (20px less than tallest) and restore display from CSS (active state)
        var heightToApply = Math.max(0, maxHeight - 30);
        allContent.forEach(function(el) {
            el.style.minHeight = heightToApply + 'px';
            el.style.display = '';
        });
    }

    // Initialize on load
    initializeMobileAccordion();
    setRightColumnMinHeight();

    // Re-initialize on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (isMobile()) {
                initializeMobileAccordion();
                allContent.forEach(function(el) { el.style.minHeight = ''; });
            } else {
                setRightColumnMinHeight();
                // Reset desktop state
                accordionTriggers.forEach(t => {
                    t.classList.remove('accordion-open');
                });
                allMobileContent.forEach(content => {
                    content.classList.remove('active');
                });
            }
        }, 250);
    });
});